import * as angular from "angular";
import {ViewSettingsService} from "../commons/services/view-settings-service.service";
import {ViewSettingsType} from "../commons/models/view-settings.model";
import {DashboardsServiceService} from "./services/dashboards-service.service";
import {DashboardsRequestsService} from "./services/dashboards-requests.service";

angular
  .module('bringoz.admin.dashboards')
  .config(dashboardConfig);

function dashboardConfig($stateProvider) {

  $stateProvider

    // Customers
    .state('dashboards', {
      parent: 'bringoz.site',
      url: '/dashboards',
      controllerAs: 'vm',
      template: '<dashboards-view favorite-dashboard="vm.favoriteDashboard" favorite-dashboard-settings="vm.favoriteDashboardSettings"' +
        ' datasource-configurations="vm.datasourceConfigurations" user-operational-data="vm.userOperationalData"></dashboards-view>',
      controller: function (triBreadcrumbsService, favoriteDashboardSettings, favoriteDashboard, datasourceConfigurations,
                            userOperationalData,site) {

        this.favoriteDashboardSettings = favoriteDashboardSettings?.length ? favoriteDashboardSettings[0] : undefined;
        this.favoriteDashboard = favoriteDashboard?.id ? favoriteDashboard : undefined;
        this.datasourceConfigurations = datasourceConfigurations;
        this.userOperationalData = userOperationalData;


        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Dashboards"});
        triBreadcrumbsService.addCrumb({name: "Reporting & Analytics"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        favoriteDashboardSettings: function (viewSettingsService: ViewSettingsService, site) {
          return viewSettingsService.getByUser(undefined, ViewSettingsType.Dashboard);
        },
        favoriteDashboard: function (dashboardsServiceService: DashboardsServiceService, favoriteDashboardSettings, site) {
          if (favoriteDashboardSettings[0]) {
            return dashboardsServiceService.getDashboardById(favoriteDashboardSettings[0].pageName);
          } else {
            return undefined;
          }
        },
        datasourceConfigurations: function (dashboardsRequestsService: DashboardsRequestsService, site) {
          return dashboardsRequestsService.getConfigurations();
        },
        userOperationalData: function (UserService, site) {
          return UserService.getUserOperationalData();
        }
      }
    })


}
